import * as React from 'react';
import InboundService from '../../shared/services/InboundService';
import DocumentsService from '../../shared/services/DocumentsService';
import ContainersService from '../../shared/services/ContainersService';
import WarehouseService from '../../shared/services/WarehouseService';
import PackingListService from '../../shared/services/PackingListService';

export interface WarehouseInboundContextValues {
  inboundService: InboundService;
  documentsService: DocumentsService;
  containersService: ContainersService;
  packingListService: PackingListService;
  warehouseService: WarehouseService;
}

const defaultValues: WarehouseInboundContextValues = {
  inboundService: null,
  documentsService: null,
  containersService: null,
  packingListService: null,
  warehouseService: null
};

const WarehouseInboundContext = React.createContext(defaultValues);

export default WarehouseInboundContext;
